module.exports = __webpack_public_path__ + "static/Gotham-XLight-034f768dabf36398c9eb42fc47b5c401.ttf";